import {BaseSingleInputComponent, BaseSingleInputComponentController} from '../baseSingleInput.component';

export interface ISelectInputOptionsProvider {
    getOptionsBinding(): string;

    getOptionsList(): any;
}

export class SelectInputComponent extends BaseSingleInputComponent {
    protected getController(): typeof BaseSingleInputComponentController {
        return SelectInputComponentController;
    }

    protected getTemplateUrl(): string {
        return './modules/quoteWizard/components/singleInputComponents/select/selectInput.view.html';
    }

    protected getBindings(): any {
        return {};
    }
}

// internal interface between the component and the controller -- this is the controller's API
interface ISelectInputComponentController {
    goNext(): void;

    goBack(): void;
}

// tslint:disable-next-line:max-classes-per-file
export class SelectInputComponentController extends BaseSingleInputComponentController implements ISelectInputComponentController {
    public optionsBinding: string;
    public options: any;
    public isReady: boolean = false;

    public static $inject = ['$scope', 'ValidationService', '$state', '$injector'];

    constructor($scope: any, validationService: any, $state?: any, $injector?: any) {
        super($scope, validationService);

        const data = (angular.isUndefined($state.current.views.selectOptions) ? {} : $state.current.views.selectOptions).data;
        if (angular.isDefined(data) && angular.isDefined(data.optionsProvider))
        {
            const provider = data.optionsProvider;
            // select options can either be an instance of ISelectInputOptionsProvider, or an angular injectable
            if (angular.isArray(provider)) {
                $injector.invoke(data.optionsProvider).then((providerResult) => {
                    this.bindOptionsProvider(providerResult);
                    this.isReady = true;
                });
            }
            else {
                this.bindOptionsProvider(provider);
                this.isReady = true;
            }
            
        }
    }
    
    private bindOptionsProvider(optionsProvider: any) {
        if (this.isISelectInputOptionsProvider(optionsProvider)) {
            this.options = optionsProvider.getOptionsList();
            this.optionsBinding = optionsProvider.getOptionsBinding();
        }
    }

    private isISelectInputOptionsProvider(optionsProvider: any): optionsProvider is ISelectInputOptionsProvider {
        return (optionsProvider as ISelectInputOptionsProvider).getOptionsBinding !== undefined;
    }
}
